const WEEK_DAYS = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

export function formatDate(value: string) {
  const [year, month, day] = value.split('-');
  return `${year}.${month}.${day}`;
}

export function formatDateCn(value: string) {
  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日 ${WEEK_DAYS[date.getDay()]}`;
}

export function splitDate(value: string) {
  const [year, month, day] = value.split('-');
  return { year, month, day };
}

export function episodeNo(episode: number) {
  return `第 ${String(episode).padStart(2, '0')} 集`;
}

export function daysBetween(from: string, to: string) {
  const a = new Date(`${from}T00:00:00`).getTime();
  const b = new Date(`${to}T00:00:00`).getTime();
  return Math.round((b - a) / 86400000);
}